const formatNumber = (arg: string | number) => {
  return Intl.NumberFormat('Ru-ru', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(Number(arg))
}

export { formatNumber }
